import { range, reverse } from 'lodash-es';
import { asString, paddedHex, hexString } from '../util/misc.js';
import { revisionNumberToString } from './version-string.js';
export var LogIndex;
(function (LogIndex) {
    LogIndex[LogIndex["Audit"] = 0] = "Audit";
    LogIndex[LogIndex["Fault"] = 1] = "Fault";
})(LogIndex || (LogIndex = {}));
export var AuditLog1Type;
(function (AuditLog1Type) {
    AuditLog1Type[AuditLog1Type["ChargeStarted"] = 0] = "ChargeStarted";
    AuditLog1Type[AuditLog1Type["ChargerDisconnected"] = 1] = "ChargerDisconnected";
    AuditLog1Type[AuditLog1Type["ChargeCompleted"] = 2] = "ChargeCompleted";
    AuditLog1Type[AuditLog1Type["HeatCycleStarted1"] = 3] = "HeatCycleStarted1";
    AuditLog1Type[AuditLog1Type["PreheatAborted1"] = 4] = "PreheatAborted1";
    AuditLog1Type[AuditLog1Type["ActiveHeatAborted1"] = 5] = "ActiveHeatAborted1";
    AuditLog1Type[AuditLog1Type["HeatCycleCompleted1"] = 6] = "HeatCycleCompleted1";
    AuditLog1Type[AuditLog1Type["HeatCycleBoosted1"] = 7] = "HeatCycleBoosted1";
    AuditLog1Type[AuditLog1Type["SystemReset"] = 8] = "SystemReset";
    AuditLog1Type[AuditLog1Type["HeatCycleActive1"] = 9] = "HeatCycleActive1";
    AuditLog1Type[AuditLog1Type["FactoryReset"] = 10] = "FactoryReset";
    AuditLog1Type[AuditLog1Type["ClockAdjustment"] = 11] = "ClockAdjustment";
    AuditLog1Type[AuditLog1Type["HeatCycleFaulted1"] = 12] = "HeatCycleFaulted1";
    AuditLog1Type[AuditLog1Type["MoodLightEnded"] = 13] = "MoodLightEnded";
    AuditLog1Type[AuditLog1Type["BleBonded"] = 14] = "BleBonded";
    AuditLog1Type[AuditLog1Type["HeatCycleStarted2"] = 15] = "HeatCycleStarted2";
    AuditLog1Type[AuditLog1Type["PreheatAborted2"] = 16] = "PreheatAborted2";
    AuditLog1Type[AuditLog1Type["ActiveHeatAborted2"] = 17] = "ActiveHeatAborted2";
    AuditLog1Type[AuditLog1Type["HeatCycleCompleted2"] = 18] = "HeatCycleCompleted2";
    AuditLog1Type[AuditLog1Type["HeatCycleBoosted2"] = 19] = "HeatCycleBoosted2";
    AuditLog1Type[AuditLog1Type["HeatCycleActive2"] = 20] = "HeatCycleActive2";
    AuditLog1Type[AuditLog1Type["HeatCycleFaulted2"] = 21] = "HeatCycleFaulted2";
})(AuditLog1Type || (AuditLog1Type = {}));
export var FaultLog1Type;
(function (FaultLog1Type) {
    FaultLog1Type[FaultLog1Type["LowBatteryCapacity"] = 0] = "LowBatteryCapacity";
    FaultLog1Type[FaultLog1Type["ChargeTemperatureStop"] = 1] = "ChargeTemperatureStop";
    FaultLog1Type[FaultLog1Type["HeatCycleStartBattFault"] = 2] = "HeatCycleStartBattFault";
    FaultLog1Type[FaultLog1Type["HeaterCurrentSenseFault"] = 3] = "HeaterCurrentSenseFault";
    FaultLog1Type[FaultLog1Type["HeaterShortCircuit"] = 4] = "HeaterShortCircuit";
    FaultLog1Type[FaultLog1Type["HeaterOpenCircuit"] = 5] = "HeaterOpenCircuit";
    FaultLog1Type[FaultLog1Type["HeaterTempErratic"] = 6] = "HeaterTempErratic";
    FaultLog1Type[FaultLog1Type["HeaterTempLost"] = 7] = "HeaterTempLost";
    FaultLog1Type[FaultLog1Type["HeaterSafetyThermalViolation"] = 8] = "HeaterSafetyThermalViolation";
    FaultLog1Type[FaultLog1Type["LowBatteryVoltage"] = 9] = "LowBatteryVoltage";
    FaultLog1Type[FaultLog1Type["HighBatteryTemp"] = 10] = "HighBatteryTemp";
    FaultLog1Type[FaultLog1Type["BondFailed"] = 11] = "BondFailed";
    FaultLog1Type[FaultLog1Type["SystemReset"] = 12] = "SystemReset";
    FaultLog1Type[FaultLog1Type["ClockAdjustment"] = 13] = "ClockAdjustment";
    FaultLog1Type[FaultLog1Type["CrashDump"] = 14] = "CrashDump";
    FaultLog1Type[FaultLog1Type["HeaterDump"] = 15] = "HeaterDump";
    FaultLog1Type[FaultLog1Type["HeaterDriverShort"] = 16] = "HeaterDriverShort";
})(FaultLog1Type || (FaultLog1Type = {}));
export var MoodlightType;
(function (MoodlightType) {
    MoodlightType["None"] = "None";
    MoodlightType["Lantern"] = "Lantern";
    MoodlightType["HeatCycle"] = "Heat Cycle";
    MoodlightType["HeatCycleDisco"] = "Heat Cycle Disco";
})(MoodlightType || (MoodlightType = {}));
const moodlightTypes = [
    MoodlightType.None,
    MoodlightType.Lantern,
    MoodlightType.HeatCycle,
    MoodlightType.HeatCycleDisco,
];
export const getMoodlightType = (type) => {
    return moodlightTypes[type];
};
const chargeStartFreeze = (view) => {
    const startDegC = view.getInt8(5);
    const startVolts = view.getUint16(6, true) / 1000;
    return [
        { name: 'Start voltage', value: startVolts.toFixed(3) + ' V' },
        { name: 'Start temp', value: startDegC.toFixed(0) + ' degC' },
    ];
};
const chargeEndFreeze = (view) => {
    const startVolts = view.getUint16(6, true) / 1000;
    const endVolts = view.getUint16(8, true) / 1000;
    const startDegC = view.getInt8(10);
    const endDegC = view.getInt8(11);
    const elapsed = view.getUint16(12, true);
    const mah = view.getUint16(14, true) / 3.6;
    return [
        { name: 'Start voltage', value: startVolts.toFixed(3) + ' V' },
        { name: 'End voltage', value: endVolts.toFixed(3) + ' V' },
        { name: 'Start temp', value: startDegC.toFixed(0) + ' degC' },
        { name: 'End temp', value: endDegC.toFixed(0) + ' degC' },
        { name: 'Elapsed time', value: elapsed.toFixed(0) + ' sec' },
        { name: 'Charge', value: mah.toFixed(0) + ' mAh' },
    ];
};
const heatCycle1Freeze = (view) => {
    const heaterTypeAndCycle = view.getUint8(5);
    const nominalTemp = view.getInt16(6, true) / 10;
    const commandedTemp = view.getInt16(8, true) / 10;
    const actualTemp = view.getInt16(10, true) / 10;
    const stateTotalTime = view.getUint16(12, true) / 100;
    const stateElapsedTime = view.getUint16(14, true) / 100;
    const heaterType = { 0: 'None', 1: 'OG', 2: 'XL', 3: '3D' }[heaterTypeAndCycle & 0xf] ?? 'Unknown';
    const freeze = [
        { name: 'Chamber type', value: heaterType },
        { name: 'Nominal temp', value: nominalTemp.toFixed(1) + ' degC' },
        { name: 'Commanded temp', value: commandedTemp.toFixed(1) + ' degC' },
        { name: 'Actual temp', value: actualTemp.toFixed(1) + ' degC' },
        { name: 'Total time', value: stateTotalTime.toFixed(2) + ' sec' },
        { name: 'Elapsed time', value: stateElapsedTime.toFixed(2) + ' sec' },
    ];
    if (heaterTypeAndCycle & 0x80) {
        const cycleIndex = { 0x7: 'Temp', 0: '1', 1: '2', 2: '3', 3: '4' }[(heaterTypeAndCycle >> 4) & 0x7] ??
            'Unknown';
        freeze.unshift({ name: 'Cycle index', value: cycleIndex });
    }
    return freeze;
};
const heatCycle2Freeze = (view) => {
    const heaterTypeAndHandshake = view.getUint8(5);
    const cycle = view.getUint8(6);
    const nominalTemp = view.getUint8(7) + 150;
    const commandedTemp = view.getUint8(8) + 150;
    const actualTemp = view.getUint8(9) + 150;
    const stateTotalTime = view.getUint16(10, true) / 100;
    const stateElapsedTime = view.getUint16(12, true) / 100;
    const heaterType = { 0: 'None', 1: 'OG', 2: 'XL', 3: '3D' }[heaterTypeAndHandshake & 0xf] ?? 'Unknown';
    const cableType = { 0: 'None', 1: 'Peak Pro Link' }[heaterTypeAndHandshake >> 4] ?? 'Unknown';
    const cycleIndex = { 0x7: 'Temp', 0: '1', 1: '2', 2: '3', 3: '4' }[cycle & 0x7] ?? 'Unknown';
    const freeze = [
        { name: 'Chamber type', value: heaterType },
        { name: 'Cable type', value: cableType },
        { name: 'Cycle index', value: cycleIndex },
        { name: 'Nominal temp', value: nominalTemp.toFixed(1) + ' degC' },
        { name: 'Commanded temp', value: commandedTemp.toFixed(1) + ' degC' },
        { name: 'Actual temp', value: actualTemp.toFixed(1) + ' degC' },
        { name: 'Total time', value: stateTotalTime.toFixed(2) + ' sec' },
        { name: 'Elapsed time', value: stateElapsedTime.toFixed(2) + ' sec' },
    ];
    return freeze;
};
const clockAdjData = (logIndex, view) => {
    const code = logIndex ? FaultLog1Type.ClockAdjustment : AuditLog1Type.ClockAdjustment;
    if (view.getUint8(4) !== code) {
        return undefined;
    }
    const newTime = view.getUint32(0, true);
    const oldTime = view.getUint32(8, true);
    const uptime = view.getUint32(12, true);
    const delta = newTime - oldTime;
    return { newTime, oldTime, uptime, delta };
};
const isReboot = (logIndex, view) => {
    const code = logIndex ? FaultLog1Type.SystemReset : AuditLog1Type.SystemReset;
    return view.getUint8(4) === code; // ? { reboot: true } : undefined;
};
const clockAdjFreeze = (logIndex, view) => {
    const { oldTime, uptime, delta } = clockAdjData(logIndex, view) ?? {
        oldTime: 0,
        uptime: 0,
        delta: 0,
    };
    return [
        { name: 'Previous time', value: new Date(oldTime * 1000).toLocaleString() },
        { name: 'Delta', value: `${delta > 0 ? '+' : ''}${delta} sec` },
        { name: 'Uptime', value: uptime.toFixed() + ' sec' },
    ];
};
const systemResetFreeze = (view) => {
    const fwVersion = view.getUint8(7);
    const causeCode = view.getUint32(8, true);
    const bootCount = view.getUint32(12, true);
    const causeStrings = [];
    if (causeCode & 1) {
        causeStrings.push('Power-on');
    }
    if (!(causeCode & 1)) {
        if (causeCode & (1 << 2)) {
            causeStrings.push('AVDD brown-out');
        }
        if (causeCode & (1 << 3)) {
            causeStrings.push('DVDD brown-out');
        }
        if (causeCode & (1 << 4)) {
            causeStrings.push('DEC brown-out');
        }
        if (causeCode & (1 << 8)) {
            causeStrings.push('Pin');
        }
    }
    if (!(causeCode & 0b11101)) {
        if (causeCode & (1 << 9)) {
            causeStrings.push('Lockup');
        }
        if (causeCode & (1 << 10)) {
            causeStrings.push('Software request');
        }
        if (causeCode & (1 << 11)) {
            causeStrings.push('Watchdog');
        }
        if (causeCode & (1 << 16)) {
            causeStrings.push('EM4');
        }
    }
    return [
        { name: 'FW', value: revisionNumberToString(fwVersion) },
        { name: 'Cause', value: causeStrings.length ? causeStrings.join(', ') : 'Unknown' },
        { name: 'Boot count', value: bootCount.toFixed(0) },
    ];
};
const moodLightEndFreeze = (view) => {
    const type = view.getUint8(5);
    const duration = view.getUint16(6, true);
    const ulid = range(8, 16)
        .map((i) => paddedHex(view.getUint8(i), 2))
        .join(' ')
        .toUpperCase();
    return [
        { name: 'Type', value: getMoodlightType(type) ?? 'Unknown' },
        { name: 'Duration', value: duration + ' sec' },
        { name: 'ULID8', value: ulid },
    ];
};
const bleBondedFreeze = (view) => {
    const mac = view.buffer.slice(5, 11);
    const bytes = Array.from(new Uint8Array(mac));
    const hexes = bytes.map((b) => paddedHex(b, 2).toUpperCase());
    reverse(hexes);
    return [{ name: 'MAC', value: hexes.join(':') }];
};
const lowCapacityFreeze = (view) => {
    const startSoc = view.getUint16(6, true) / 100;
    const endSoc = view.getUint16(8, true) / 100;
    const startDegC = view.getInt8(10);
    const endDegC = view.getInt8(11);
    const elapsed = view.getUint16(12, true);
    const mah = view.getUint16(14, true) / 3.6;
    return [
        { name: 'Start SOC', value: startSoc.toFixed(2) + '%' },
        { name: 'End SOC', value: endSoc.toFixed(2) + '%' },
        { name: 'Start temp', value: startDegC.toFixed(0) + ' degC' },
        { name: 'End temp', value: endDegC.toFixed(0) + ' degC' },
        { name: 'Elapsed time', value: elapsed.toFixed(0) + ' sec' },
        { name: 'Charge', value: mah.toFixed(0) + ' mAh' },
    ];
};
const heatCycleStartBattFaultFreeze = (view) => {
    const version = view.getUint8(5);
    const startVolts = view.getUint16(6, true) / 1000;
    const record = [{ name: 'Batt Voltage', value: startVolts.toFixed(3) + ' V' }];
    if (version > 0) {
        const startTemp = view.getInt16(8, true) / 10;
        const startSoc = view.getUint16(10, true) / 100;
        record.push({ name: 'Batt Temp', value: startTemp.toFixed(1) + ' °C' });
        record.push({ name: 'Batt SOC', value: startSoc.toFixed(2) + ' %' });
    }
    return record;
};
const heaterCurrentFaultFreeze = (view) => {
    const currentSensorVolts = view.getUint16(6, true) / 1000;
    const heaterCurrent = view.getInt16(8, true) / 1000;
    const batteryVolts = view.getUint16(10, true) / 1000;
    const dutyCycle = view.getUint16(12, true) / 100;
    return [
        { name: 'Current sensor output', value: currentSensorVolts.toFixed(3) + ' V' },
        { name: 'Heater current', value: heaterCurrent.toFixed(3) + ' A' },
        { name: 'Battery', value: batteryVolts.toFixed(3) + ' V' },
        { name: 'Duty cycle', value: dutyCycle.toFixed(2) + '%' },
    ];
};
const heaterTempErraticFreeze = (view) => {
    const prevTemp = view.getInt16(6, true) / 10;
    const currentTemp = view.getInt16(8, true) / 10;
    return [
        { name: 'Previous temp', value: prevTemp.toFixed(1) + ' degC' },
        { name: 'Current temp', value: currentTemp.toFixed(1) + ' degC' },
    ];
};
const heaterTempLostFreeze = (view) => {
    const code = view.getUint16(6, true);
    return [{ name: 'Raw code', value: '0x' + paddedHex(code, 4).toUpperCase() }];
};
const safetyThermalFreeze = (view) => {
    const commandedTemp = view.getInt16(6, true) / 10;
    const estimatedTemp = view.getInt16(8, true) / 10;
    const measuredTemp = view.getInt16(10, true) / 10;
    return [
        { name: 'Commanded temp', value: commandedTemp.toFixed(1) + ' degC' },
        { name: 'Estimated temp', value: estimatedTemp.toFixed(1) + ' degC' },
        { name: 'Measured temp', value: measuredTemp.toFixed(1) + ' degC' },
    ];
};
const batteryCriticalFreeze = (view) => {
    const temp = view.getInt8(5);
    const voltage = view.getUint16(6, true) / 1000;
    return [
        { name: 'Battery temp', value: temp.toFixed(1) + ' degC' },
        { name: 'Battery voltage', value: voltage.toFixed(3) + ' V' },
    ];
};
const bondFailedFreeze = (view) => {
    const reason = view.getUint16(6, true);
    const connHandle = view.getUint8(8);
    const bondHandle = view.getUint8(9);
    return [
        { name: 'Reason', value: '0x' + paddedHex(reason, 4).toUpperCase() },
        {
            name: 'Conn handle',
            value: '0x' + paddedHex(connHandle, 2).toUpperCase(),
        },
        {
            name: 'Bond handle',
            value: '0x' + paddedHex(bondHandle, 2).toUpperCase(),
        },
    ];
};
const segmentedDumpFreeze = (view) => {
    const index = view.getUint8(5);
    const records = [{ name: 'Index', value: index.toFixed(0) }];
    let data;
    if (index === 0) {
        const totalSize = view.getUint16(6, true);
        records.push({ name: 'Total size', value: totalSize.toFixed(0) });
        data = view.buffer.slice(8);
    }
    else {
        data = view.buffer.slice(6);
    }
    records.push({ name: 'Payload', value: hexString(data) });
    return records;
};
/** Record obtained from audit or fault log */
export class LogRecord {
    logIndex;
    recordIndex;
    bytes;
    /** Human-readable type of the record */
    title = 'Parse Error';
    /** Localized string of the uncorrected record timestamp */
    rawDateString = 'Unknown';
    /** Localized string of the corrected record timestamp */
    correctedDateString = 'Unknown';
    /** Detailed information from the record */
    freeze = [];
    /** Uncorrected record timestamp */
    rawDate;
    /** Corrected record timestamp */
    correctedDate;
    /** Code representing the type of the record */
    typeCode;
    constructor(logIndex, recordIndex, bytes, epoch) {
        this.logIndex = logIndex;
        this.recordIndex = recordIndex;
        this.bytes = bytes;
        try {
            if (bytes.byteLength < 16) {
                throw 'Invalid length';
            }
            const view = new DataView(bytes);
            const rawDate = view.getUint32(0, true);
            this.rawDate = new Date(rawDate * 1000);
            this.correctedDate = new Date(epoch.correct(rawDate) * 1000);
            this.typeCode = view.getUint8(4);
            this.rawDateString = this.rawDate.toLocaleString();
            this.correctedDateString = this.correctedDate.toLocaleString();
            switch (logIndex) {
                case LogIndex.Audit:
                    this.parseAudit(view);
                    break;
                case LogIndex.Fault:
                    this.parseFault(view);
                    break;
            }
        }
        catch (err) {
            this.freeze.unshift({ name: 'Error', value: asString(err) });
        }
        this.freeze.push({
            name: 'Raw Data',
            value: Array.from(new Uint8Array(bytes))
                .map((b) => paddedHex(b, 2))
                .join(' ')
                .toUpperCase(),
        });
    }
    parseAudit(view) {
        switch (this.typeCode) {
            case AuditLog1Type.ChargeStarted:
                this.title = 'Charge Started';
                this.freeze = chargeStartFreeze(view);
                break;
            case AuditLog1Type.ChargerDisconnected:
                this.title = 'Charger Disconnected';
                this.freeze = chargeEndFreeze(view);
                break;
            case AuditLog1Type.ChargeCompleted:
                this.title = 'Charge Completed';
                this.freeze = chargeEndFreeze(view);
                break;
            case AuditLog1Type.HeatCycleStarted1:
                this.title = 'Heat Cycle Started';
                this.freeze = heatCycle1Freeze(view);
                break;
            case AuditLog1Type.PreheatAborted1:
                this.title = 'Preheat Aborted';
                this.freeze = heatCycle1Freeze(view);
                break;
            case AuditLog1Type.ActiveHeatAborted1:
                this.title = 'Active Heat Aborted';
                this.freeze = heatCycle1Freeze(view);
                break;
            case AuditLog1Type.HeatCycleCompleted1:
                this.title = 'Heat Cycle Completed';
                this.freeze = heatCycle1Freeze(view);
                break;
            case AuditLog1Type.HeatCycleBoosted1:
                this.title = 'Heat Cycle Boosted';
                this.freeze = heatCycle1Freeze(view);
                break;
            case AuditLog1Type.SystemReset:
                this.title = 'System Reset';
                this.freeze = systemResetFreeze(view);
                break;
            case AuditLog1Type.HeatCycleActive1:
                this.title = 'Heat Cycle Active';
                this.freeze = heatCycle1Freeze(view);
                break;
            case AuditLog1Type.FactoryReset:
                this.title = 'Factory Reset';
                this.freeze = [];
                break;
            case AuditLog1Type.ClockAdjustment:
                this.title = 'Clock Adjustment';
                this.freeze = clockAdjFreeze(0, view);
                break;
            case AuditLog1Type.HeatCycleFaulted1:
                this.title = 'Heat Cycle Faulted';
                this.freeze = heatCycle1Freeze(view);
                break;
            case AuditLog1Type.MoodLightEnded:
                this.title = 'Mood Light Ended';
                this.freeze = moodLightEndFreeze(view);
                break;
            case AuditLog1Type.BleBonded:
                this.title = 'BLE Bonded';
                this.freeze = bleBondedFreeze(view);
                break;
            case AuditLog1Type.HeatCycleStarted2:
                this.title = 'Heat Cycle Started';
                this.freeze = heatCycle2Freeze(view);
                break;
            case AuditLog1Type.PreheatAborted2:
                this.title = 'Preheat Aborted';
                this.freeze = heatCycle2Freeze(view);
                break;
            case AuditLog1Type.ActiveHeatAborted2:
                this.title = 'Active Heat Aborted';
                this.freeze = heatCycle2Freeze(view);
                break;
            case AuditLog1Type.HeatCycleCompleted2:
                this.title = 'Heat Cycle Completed';
                this.freeze = heatCycle2Freeze(view);
                break;
            case AuditLog1Type.HeatCycleBoosted2:
                this.title = 'Heat Cycle Boosted';
                this.freeze = heatCycle2Freeze(view);
                break;
            case AuditLog1Type.HeatCycleActive2:
                this.title = 'Heat Cycle Active';
                this.freeze = heatCycle2Freeze(view);
                break;
            case AuditLog1Type.HeatCycleFaulted2:
                this.title = 'Heat Cycle Faulted';
                this.freeze = heatCycle2Freeze(view);
                break;
            default:
                throw ('Unknown type code ' +
                    (this.typeCode === undefined
                        ? 'undefined'
                        : paddedHex(this.typeCode, 2).toUpperCase()));
        }
    }
    parseFault(view) {
        switch (this.typeCode) {
            case FaultLog1Type.LowBatteryCapacity:
                this.title = 'Low Battery Capacity';
                this.freeze = lowCapacityFreeze(view);
                break;
            case FaultLog1Type.ChargeTemperatureStop:
                this.title = 'Charge Temperature Stop';
                this.freeze = chargeEndFreeze(view);
                break;
            case FaultLog1Type.HeatCycleStartBattFault:
                this.title = 'Heat Cycle Start Batt Fault';
                this.freeze = heatCycleStartBattFaultFreeze(view);
                break;
            case FaultLog1Type.HeaterCurrentSenseFault:
                this.title = 'Heater Current Sense Fault';
                this.freeze = heaterCurrentFaultFreeze(view);
                break;
            case FaultLog1Type.HeaterShortCircuit:
                this.title = 'Heater Short Circuit';
                this.freeze = heaterCurrentFaultFreeze(view);
                break;
            case FaultLog1Type.HeaterOpenCircuit:
                this.title = 'Heater Open Circuit';
                this.freeze = heaterCurrentFaultFreeze(view);
                break;
            case FaultLog1Type.HeaterTempErratic:
                this.title = 'Heater Temp Erratic';
                this.freeze = heaterTempErraticFreeze(view);
                break;
            case FaultLog1Type.HeaterTempLost:
                this.title = 'Heater Temp Lost';
                this.freeze = heaterTempLostFreeze(view);
                break;
            case FaultLog1Type.HeaterSafetyThermalViolation:
                this.title = 'Heater Safety Thermal Violation';
                this.freeze = safetyThermalFreeze(view);
                break;
            case FaultLog1Type.LowBatteryVoltage:
                this.title = 'Low Battery Voltage';
                this.freeze = batteryCriticalFreeze(view);
                break;
            case FaultLog1Type.HighBatteryTemp:
                this.title = 'High Battery Temp';
                this.freeze = batteryCriticalFreeze(view);
                break;
            case FaultLog1Type.BondFailed:
                this.title = 'Bond Failed';
                this.freeze = bondFailedFreeze(view);
                break;
            case FaultLog1Type.SystemReset:
                this.title = 'System Reset';
                this.freeze = systemResetFreeze(view);
                break;
            case FaultLog1Type.ClockAdjustment:
                this.title = 'Clock Adjustment';
                this.freeze = clockAdjFreeze(1, view);
                break;
            case FaultLog1Type.CrashDump:
                this.title = 'Crash Dump';
                this.freeze = segmentedDumpFreeze(view);
                break;
            case FaultLog1Type.HeaterDump:
                this.title = 'Heater Dump';
                this.freeze = segmentedDumpFreeze(view);
                break;
            case FaultLog1Type.HeaterDriverShort:
                this.title = 'Heater Driver Short';
                this.freeze = heaterCurrentFaultFreeze(view);
                break;
            default:
                throw ('Unknown type code ' +
                    (this.typeCode === undefined
                        ? 'undefined'
                        : paddedHex(this.typeCode, 2).toUpperCase()));
        }
    }
}
export class AdjEpoch {
    beginOffset;
    endOffset;
    correct;
    constructor(begin, end) {
        this.beginOffset = begin.offset;
        this.endOffset = end.offset;
        if (end.data) {
            if (begin.data) {
                // Between two clock adjusts, linearize between ends
                const beginDelta = 0;
                const endDelta = end.data.delta;
                const beginTime = begin.data.newTime;
                const endTime = end.data.oldTime;
                this.correct = (raw) => {
                    if (raw > beginTime && raw < endTime) {
                        return (raw +
                            ((raw - beginTime) / (endTime - beginTime)) * (endDelta - beginDelta) +
                            beginDelta);
                    }
                    else if (raw <= beginTime) {
                        return raw + beginDelta;
                    }
                    else {
                        return raw + endDelta;
                    }
                };
            }
            else {
                // Between a system reset and a clock adjust, constant offset equal to clock adjust's
                const delta = end.data.delta;
                this.correct = (raw) => raw + delta;
            }
        }
        else {
            // Between a clock adjust and a system reset, zero offset
            // Between two system resets, zero offset
            this.correct = (raw) => raw;
        }
    }
}
/** @returns true if the record is one that would affect the adjustment epochs */
export const isClockAdjRecord = (logIndex, buffer) => {
    const view = new DataView(buffer);
    return !!clockAdjData(logIndex, view) || isReboot(logIndex, view);
};
/** @returns adjustment epochs (ranges of entries associated with various linear transforms) for the log entries */
export const getClockAdjEpochs = (logIndex, raw) => {
    // Pick out entries that would affect the clock
    // Offsets here are relative to start of log, so we don't need mod32
    const bootCycles = [{ beginOffset: -Infinity, clockAdjusts: [], endOffset: NaN }];
    for (const [i, entry] of raw.entries()) {
        const view = new DataView(entry.buffer);
        const clockAdj = clockAdjData(logIndex, view);
        if (clockAdj) {
            bootCycles[bootCycles.length - 1].clockAdjusts.push({ offset: i, data: clockAdj });
        }
        else if (isReboot(logIndex, view)) {
            bootCycles[bootCycles.length - 1].endOffset = i;
            bootCycles.push({ beginOffset: i, clockAdjusts: [], endOffset: NaN }); // and start a new cycle with the real reboot
        }
    }
    bootCycles[bootCycles.length - 1].endOffset = Infinity;
    if (!bootCycles.every((cycle) => !isNaN(cycle.beginOffset) && !isNaN(cycle.endOffset))) {
        throw new Error('Logic error: incomplete boot cycle');
    }
    // Define adjustment epochs: ranges of entries associated with various linear transforms
    const epochs = [];
    for (const cycle of bootCycles) {
        const cycleEpochEnds = [
            { offset: cycle.beginOffset },
            ...cycle.clockAdjusts,
            { offset: cycle.endOffset },
        ];
        for (let i = 1; i < cycleEpochEnds.length; ++i) {
            epochs.push(new AdjEpoch(cycleEpochEnds[i - 1], cycleEpochEnds[i]));
        }
    }
    return epochs;
};
/** Transform raw data to a single record, applying running clock corrections */
export const makeRecord = (logIndex, raw, offset, epochs) => {
    const epoch = epochs.find((e) => offset < e.endOffset);
    if (!epoch) {
        throw new Error(`Epoch not found for entry offset ${offset}`);
    }
    return new LogRecord(logIndex, raw.index, raw.buffer, epoch);
};
/** Transform raw data to a set of records, applying running clock corrections */
export const makeRecords = (logIndex, raw, epochs) => {
    const out = [];
    out.length = raw.length;
    let iEpoch = 0;
    for (let offset = 0; offset < raw.length; ++offset) {
        if (offset >= epochs[iEpoch].endOffset) {
            ++iEpoch;
        }
        out[offset] = new LogRecord(logIndex, raw[offset].index, raw[offset].buffer, epochs[iEpoch]);
    }
    return out;
};
//# sourceMappingURL=log-1-record.js.map